// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const SliderThumbInteraction = createStyle({
  borderRadius: 9999,
  zIndex: -1,
});
